export const remCoefficient =
  parseFloat(getComputedStyle(document.documentElement).fontSize) ?? 16;

export const pxToRem = (value: number): number => value / remCoefficient;
